import type { IconAsset } from '../Icon.types';

const code = (
  <path
    clipRule='evenodd'
    d='M12,12A4,4,0,1,0,8,8,4,4,0,0,0,12,12Zm0,2c-2.67,0-8,1.34-8,4v2H20V18C20,15.34,14.67,14,12,14Z'
    fill='currentColor'
    fillRule='evenodd'
  />
);

export const account: IconAsset = {
  regular: {
    l: {
      code,
    },
    m: {
      code,
    },
    s: {
      code,
    },
  },
};
